<template>
  <div>
    <template>
      <h4 class="not-margin"
          :style="{ fontWeight: 'bold', color: '#195BFF', fontSize: '18px', textAlign: 'left' }">
        <i class="fal fa-plus-circle" :style="{ width: '25px', fontSize: '18px' }"></i>
        ເພີ່ມລົດຂົນສົ່ງ
      </h4>
    </template>

    <div class="field" :style="{marginTop: '20px'}">
      <div class="control">
        <label class="label">
          ທະບຽນລົດ
          <span class="text-danger">* {{ errors.first('plate_number') }}</span>
          <span class="text-danger">{{ server_errors.plate_number }}</span>
        </label>
        <input class="input" name="plate_number" placeholder="ກະລຸນາປ້ອນທະບຽນລົດ..."
               v-model="truckValue.plate_number" v-validate="'required|max:50'">
      </div>
    </div>
    <div class="field">
      <div class="control">
        <label class="label">
          ປະເພດລົດ
          <span class="text-danger">* {{ errors.first('vehicle_type') }}</span>
          <span class="text-danger">{{ server_errors.vehicle_type }}</span>
        </label>
        <input class="input" name="vehicle_type" placeholder="ຕົວຢ່າງ: 6 ລໍ້, 10 ລໍ້, ຕູ້..."
               v-model="truckValue.vehicle_type" v-validate="'required|max:50'">
      </div>
    </div>
    <div class="field">
      <div class="control">
        <label class="label">
          ຂະໜາດລົດ
          <span class="text-danger">{{ server_errors.size_class }}</span>
        </label>
        <div class="select">
          <select v-model="truckValue.size_class">
            <option v-for="(size, index) in sizeClassOptions" :key="index" :value="size.id">
              {{ size.name }}
            </option>
          </select>
        </div>
      </div>
    </div>
    <div class="field">
      <div class="control">
        <label class="label">
          ຄວາມສາມາດບັນທຸກ (kg)
          <span class="text-danger">* {{ errors.first('capacity_kg') }}</span>
          <span class="text-danger">{{ server_errors.capacity_kg }}</span>
        </label>
        <input class="input" type="number" min="0" name="capacity_kg" placeholder="ກິໂລກຣາມ..."
               v-model="truckValue.capacity_kg" v-validate="'required'">
      </div>
    </div>
    <div class="field">
      <div class="control">
        <label class="label">
          ຄວາມສາມາດບັນທຸກ (m³)
          <span class="text-danger">* {{ errors.first('capacity_cbm') }}</span>
          <span class="text-danger">{{ server_errors.capacity_cbm }}</span>
        </label>
        <input class="input" type="number" min="0" step="0.1" name="capacity_cbm" placeholder="ແມັດກ້ອນ..."
               v-model="truckValue.capacity_cbm" v-validate="'required'">
      </div>
    </div>
    <div class="field">
      <div class="control">
        <label class="label">
          ຄວາມເປັນເຈົ້າຂອງ
          <span class="text-danger">{{ server_errors.ownership }}</span>
        </label>
        <div class="select">
          <select v-model="truckValue.ownership">
            <option v-for="(item, index) in ownershipOptions" :key="index" :value="item.id">
              {{ item.name }}
            </option>
          </select>
        </div>
      </div>
    </div>
    <div class="field">
      <div class="control">
        <label class="label">
          ຊື່ທີມ (ບໍ່ບັງຄັບ)
          <span class="text-danger">{{ server_errors.team_name }}</span>
        </label>
        <input class="input" name="team_name" placeholder="ຊື່ທີມ..." v-model="truckValue.team_name">
      </div>
    </div>
    <div ref="target" id="target" class="center">
      <div class="con-btns">
        <vs-button ref="button" flat class="form-btn-loading" :loading="btnLoading" @click="ValidateForm()">
          ລົງທະບຽນລົດຂົນສົ່ງ
        </vs-button>
      </div>
    </div>
  </div>
</template>

<script>
import MixinFleetTrucks from '@/Mixins/Fleet/Trucks';

export default {
  mixins: [MixinFleetTrucks],
  methods: {
    ValidateForm() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.CreateTruck();
        }
      });
    },
  },
  created() {
    this.ResetTruckForm();
  },
};
</script>

<style scoped>
</style>
